const lastAttemptedXShareListingId = (state = false, action) => {
  switch (action.type) {
      case 'SET_LAST_ATTEMPTED_X_SHARE_LISTING_ID':
          return action.listingId
      default:
          return state
  }
}

export default lastAttemptedXShareListingId;